import { Component, OnInit, ChangeDetectorRef, AfterViewChecked, OnDestroy, AfterContentChecked, Renderer2, AfterViewInit, QueryList, ViewChildren } from '@angular/core';
import { CommonConstants } from './common/utilities/commonConstants';
import { environment } from '../environments/environment';
import { CookieHandlerService } from './common/services/cookieHandler.service';
import { SessionHandlerService } from './common/services/sessionHandler.service';
import { RouteHandlerService } from './common/services/routeHandler.service';
import { SharedService } from './common/services/sharedService';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { HomeService } from './home/home.service';
import { EmitterService } from './common/services/emitter.service';
import { AnalyticsService } from './common/services/device.analytics.service';
import { adobe_analytics_service } from './common/services/adobe_analytics_service';
import { LocationStrategy } from '@angular/common';
// import 'rxjs/add/operator/filter';
import { filter } from 'rxjs/operators';
import { PopupComponent } from './common/utilities/popup/popup.component';
import { RouteContextProvider } from './common/services/routeContextProvider.service';
import { AppIdleService } from './common/services/app-idle.service';
import { Subscription } from 'rxjs';
import { DrawerComponent } from './common/utilities/drawer/drawer.component';
import { ClevertapEventHandlerService } from './common/services/clevertap-event-handler.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewChecked, OnInit, AfterViewInit, OnDestroy {
    title = 'app';
    // Bajaj Logo goes here
    public bajajclassLogo = 'assets/img/bfs-logo-mod.png';
    public angularclassLogo = 'assets/img/angularclass-avatar.png';
    public name = 'This is test page';
    public url = 'some URL';
    public HasError: boolean;
    public IsLoadingTask = false;
    public InsuranceProductType: any;
    public showToggle = false;
    tempShow = false;
    public bflJourney = false;
    public Config = { show: false, backdrop: 'static' };
    @ViewChildren(PopupComponent) public PopupComponent: QueryList<any>;
    ContentPopup: { Id: string; Title: string; Config: CustomModalOptions; };
    public sessionExpired: boolean;
    public counting: number;
    countdownTimer: any;
    public autoLease: any;
    isMobileFlag: string;
    @ViewChildren(DrawerComponent) public drawer: QueryList<DrawerComponent>;
    sfdcUCF: any;
    isCollapsed = true;
    fullText = `- Bajaj Finance Limited (‘BFL’) is a registered corporate agent of third party insurance products of Bajaj Life Insurance Company Limited (Formerly known as Bajaj Allianz Life Insurance Company Limited), HDFC Life Insurance Company Limited, Life Insurance Corporation of India (LIC), Bajaj General Insurance Company Limited(Formerly known as Bajaj Allianz General Insurance Company Limited), SBI General Insurance Company Limited, ACKO General Insurance Company Limited, HDFC ERGO General Insurance Company, TATA AIG General Insurance Company Limited, ICICI Lombard General Insurance Company Limited, New India Assurance Limited, Chola MS General Insurance Company Limited, Zurich Kotak General Insurance Company Limited, Star Health & Allied Insurance Company Limited, Care Health Insurance Company Limited, Niva Bupa Health Insurance Company Limited, Aditya Birla Health Insurance Company Limited and Manipal Cigna Health Insurance Company Limited under the IRDAI composite registration number CA0101. Please note that, BFL does not underwrite the risk or act as an insurer. Your purchase of an insurance product is purely on a voluntary basis after your exercise of an independent due diligence on the suitability, viability of any insurance product. Any decision to purchase insurance product is solely at your own risk and responsibility and BFL shall not be liable for any loss or damage that any person may suffer, whether directly or indirectly. For more details on risk factors, terms and conditions and exclusions please read the product sales brochure & policy wordings carefully before concluding a sale. Tax benefits applicable if any, will be as per the prevailing tax laws. Tax laws are subject to change. BFL does NOT provide Tax/Investment advisory services. Please consult your advisors before proceeding to purchase an insurance product. Visitors are hereby informed that their information submitted on the website may also be shared with insurers. BFL is also distributor of other third party products from Assistance service providers such as CPP Assistance Services Private Limited, Bajaj Finserv Health Limited. etc. All product information such as premium, benefits, exclusions, value added services etc. are authentic and solely based on the information received from the respective Insurance company or the respective Assistance provider company.`;
    noteText = `Note - While we have made all the efforts and taken utmost care in gathering precise information about the products, features, benefits etc. However, BFL cannot be held liable for any direct or indirect damage/loss. We request our customers to conduct their research about these products and refer to the respective products sales brochure and policy/membership wordings before concluding sales.`

    constructor(
        private _cookieHandlerService: CookieHandlerService,
        private _sessionHandler: SessionHandlerService,
        private _routerService: RouteHandlerService,
        private _sharedservice: SharedService,
        private _emitterService: EmitterService,
        private cdRef: ChangeDetectorRef,
        private route: ActivatedRoute,
        private meta: Meta,
        private _analyticsService: AnalyticsService,
        private _adobe_analytics_service: adobe_analytics_service,
        private renderer: Renderer2,
        private location: LocationStrategy,
        private router: Router,
        private _routeContextProvider: RouteContextProvider,
        private _appIdleService: AppIdleService,
        private clevertapService: ClevertapEventHandlerService
    ) {
        this._emitterService.currentMessage.subscribe(message => {
            this.IsLoadingTask = message;
        });
        history.pushState(null, null, window.location.href);
        this.location.onPopState(() => {
            history.pushState(null, null, window.location.href);
        });
    }
    public ngAfterViewChecked() {
        this.cdRef.detectChanges();
    }
    public ngOnInit() {
        this.autoLease = this._sessionHandler.GetSession(CommonConstants.CookieKeys.autoLease);
        this.sfdcUCF = this._sessionHandler.GetSession(CommonConstants.CookieKeys.sfdcUCF);
        //On AutoLease journey, session timeout will not be activated.
        // if (this.autoLease == 'true') {
        //     return;
        // }
        // else {
        this.loadClevertapScript();
        setTimeout(() => {
            this.tempShow = true;
            //this.loadAnalyticScript();
        }, 500);
        // this.router.events
        //   .pipe(filter(event => event instanceof NavigationStart))
        //   .subscribe((event: NavigationStart) => {
        //     console.log(event);
        //     this.checkHomePage(event.url) ? this.showToggle = true : this.showToggle = false;
        //   });
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                const url = event.url;
                this.checkHomePage(event.url) ? this.showToggle = true : this.showToggle = false;
            }
        })
        this.getGeoLocationAttributes();
        console.log(this.router.url)
        this._sharedservice.theme = localStorage.getItem('theme');
        this._sharedservice.theme === 'dark' ? this.renderer.addClass(document.body, 'dark') :
            this.renderer.removeClass(document.body, 'dark');
        this._sharedservice.themeChange.subscribe(res => {
            this._sharedservice.theme = localStorage.getItem('theme');
        });

        let appId = this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
        appId = appId ? this._cookieHandlerService.GetCookie(CommonConstants.CookieKeys.LoanApplicationId, appId) : null;
        if (window.name !== '') {
            const LoanApplicationId = window.name;
            this._cookieHandlerService.SetCookie(CommonConstants.CookieKeys.LoanApplicationId, LoanApplicationId, LoanApplicationId);
        } else if (window.name === '' && appId && !this._analyticsService.GetDeviceDetails().mobile) {
            window.name = '';
            this._routerService.RouteToNextTask('multitabfailed');
            return;
        }
        // handling for service session-timeout error
        this._emitterService.Get(CommonConstants.EmitterEventTypes.SessionExpired).subscribe((isExpired: boolean) => {
            if (isExpired) {
                this.sessionExpired = true;
                this.showSessionExpiryPopup();
            } else {
                this.HideChildModal('sessionExpired');
            }
        });

        // handling for ui session-timeout error
        this._appIdleService.expired$.subscribe((isSessionExpired) => {
            if (isSessionExpired) {
                this.showSessionExpiryPopup(() => {
                    if (this.countdownTimer) {
                        clearInterval(this.countdownTimer);
                    }
                    this.countDown(CommonConstants.SESSIONEXPIRYTIMER);
                });
            }
        });
    // }
    }
    public ngAfterViewInit() {
        this.loadAnalyticScript();
    }
    public ngOnDestroy() {
        let LoanApplicationId = this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
        if (!LoanApplicationId) {
            LoanApplicationId = window.name;
        }
        if (LoanApplicationId) {
            window.name = '';
            this._cookieHandlerService.DeleteCookies([CommonConstants.CookieKeys.LoanApplicationId], LoanApplicationId);
        }
    }
    //lat and long fetch for current location 
    getGeoLocationAttributes() {
        if (!sessionStorage.getItem(CommonConstants.CookieKeys.latitude)
            && !sessionStorage.getItem(CommonConstants.CookieKeys.longitude)) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position: any) => {
                    if (position) {
                        this._sessionHandler.SetSession(CommonConstants.CookieKeys.latitude, position.coords.latitude);
                        this._sessionHandler.SetSession(CommonConstants.CookieKeys.longitude, position.coords.longitude);
                    }
                },
                    (error: any) => {});
            } else {
                console.log("Geolocation is not supported by this browser.");
            }
        }

    }
    private addAnalyticsScript() {
        const path = environment['AnalyticsLink'];
        const scriptTag = document.createElement('script');
        scriptTag.setAttribute('src', path);
        scriptTag.setAttribute('defer', 'true');
        document.head.appendChild(scriptTag);
    }
    // private addScriptToHeadTag(script: string) {
    //   const sc = document.createElement('script');
    //   sc.setAttribute('src', script);
    //   sc.setAttribute('type', 'text/javascript');
    //   document.head.appendChild(sc);
    // }
    checkHomePage(url) {
        return ((url === '/') || url.indexOf('vehicleRegistration') > -1);
    }
    private loadAnalyticScript() {
        let url: any = window.location.pathname;
        url = url.split('/');
        this.bflJourney = url.includes(CommonConstants.QueryParamsKeys.marketplace);
        if (this.bflJourney) {
            // attach analytic script to head tag
            const script = document.createElement('script');
            const inlineScript = document.createTextNode(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-TX8FNLW');`);
            script.setAttribute('type', 'text/javascript');
            script.appendChild(inlineScript);
            script.defer = true;
            document.head.appendChild(script);
        } else {
            this.addAnalyticsScript();
            this._adobe_analytics_service.initiPageInfo();
        }
    }
    public ShowChildModal(id: string, contentType?: string): void {
        if (contentType) {
            this.initContentPopup();
        }
        this.getModalDirectiveInstanceBasedOnId(id).show();
    }
    public HideChildModal(id: string): void {
        this.getModalDirectiveInstanceBasedOnId(id).hide();
    }
    private initContentPopup() {
        this.ContentPopup = {
            Id: 'content-modal',
            Title: 'Riders',
            Config: <CustomModalOptions>{ show: false, closeOption: true }
        };
    }
    private getModalDirectiveInstanceBasedOnId(popupId: string): any {
        return this.PopupComponent.filter((item: PopupComponent, index: number) => {
            return item.id === popupId;
        })[0].modalControl;
    }
    public proceed(redirectionKey, redirectionValue) {
        const platform = this._sessionHandler.GetSession(CommonConstants.CookieKeys.platform);
        const redirectionUrl = `inssdk://applaunch?redirection_key=${redirectionKey}&Redirection_value=${redirectionValue}`;
        if (platform.toLowerCase() === CommonConstants.platforms.ios) {
            window.open(redirectionUrl, '_self');
        } else if (platform.toLowerCase() === CommonConstants.platforms.android) {
            window.open(redirectionUrl, '_self');
        } else {
            sessionStorage.clear();
            this.HideChildModal('sessionExpired');
            //this.router.navigate(['/vehicleRegistration']);
            this._routeContextProvider.NavigateToView([CommonConstants.Routes.Application.VehicleRegistration]);
        }
    }

    // public showSessionExpiryPopup(callback?) {
    //     this._sessionHandler.SetSession(CommonConstants.CookieKeys.ssoEnabled, false);
    //     this.openDrawer('sessionExpired');
    //     if (callback) {
    //         callback();
    //     }
    // }

    public showSessionExpiryPopup(callback?) {
        this._sessionHandler.SetSession(CommonConstants.CookieKeys.ssoEnabled, false);
        this.ShowChildModal('sessionExpired');
        if (callback) {
            callback();
        }
    }

    public countDown(count: number) {
        this.counting = count;
        this.sessionExpired = false;
        this.countdownTimer = setInterval(() => {
            if (this.counting <= 0) {
                this.sessionExpired = true;
                clearInterval(this.countdownTimer);
                return false;
            } else {
                this.counting = this.counting - 1;
            }
        }, 1000);
    }

    public redirectToLandingPage() {
        const redirectionKey = 'INSCATEGORY';
        let redirectionValue = '';
        let vehicleType = this._sharedservice.getVehicleType();
        if (vehicleType == 'FWGI') {
            redirectionValue = 'MOTOR';
        } else if (vehicleType == 'TWGI') {
            redirectionValue = 'BIKE';
        } else if (vehicleType == 'TXGI') {
            redirectionValue = 'TAXI';
        } else if (vehicleType == 'CVGI') {
            redirectionValue = 'COMMERCIAL';
        }
        const platform = this._sessionHandler.GetSession(CommonConstants.CookieKeys.platform);
        const redirectionUrl = `inssdk://applaunch?redirection_key=${redirectionKey}&Redirection_value=${redirectionValue}`;
        const sdkVersion = this._sessionHandler.GetSession(CommonConstants.CookieKeys.sdkVersion);
        if (redirectionValue && sdkVersion && (platform.toLowerCase() === CommonConstants.platforms.ios || platform.toLowerCase() === CommonConstants.platforms.android)) {
            window.open(redirectionUrl, '_self');
        } else {
            sessionStorage.clear();
            if (this.router.url.toLowerCase() === '/vehicleregistration') {
                window.location.reload();
            } else {
                this.router.navigate(['/']).then(() => {
                    this.HideChildModal('sessionExpired');
                });
            }
        }
    }

    public closeSessionPopup() {
        this.HideChildModal('sessionExpired');
        this._appIdleService.stopTimer();
        this.redirectToLandingPage();
    }

    public extendSession() {
        const applicationId = this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
        if (applicationId) {
            const payloadObject = {
                'payload': {
                    'applicationId': applicationId
                }
            };
            this._appIdleService.ExtendSessionSerive(payloadObject).subscribe((response) => {
                if (response && response['error']) {
                    console.log('Error in extending user session :: ', response['error']);
                } else {
                    this._appIdleService.resetTimer();
                    this.HideChildModal('sessionExpired');
                }
            }, (error) => {
                console.log('Error in extending user session :: ', error);
            });
        }
    }
    // Function to load the Clevertap tracking script
  loadClevertapScript() {
    // Generate script content based on the environment
    const scriptContent = this.generateScriptContent();
    // Create a script element
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = scriptContent;

    // Append the script to the head element
    this.renderer.appendChild(document.head, script);

    // Access Clevertap object from the global window object
    this.clevertapService.clevertap = window['clevertap'];
  }

  // Function to generate the Clevertap script content
  generateScriptContent() {
    // Return the Clevertap script content as a string
    return `
    // Check for service worker and register it
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('./assets/js/service-worker.js', {
        scope: '/'
      }).then((reg) => {
        console.debug('Registration failed with');
      }).catch((error) => {
        console.debug('Registration failed with ' + error);
      });
    }

    // Initialize Clevertap object with configuration
    var clevertap = {
      event: [],
      profile: [],
      region: 'in1',
      account: [],
      onUserLogin: [],
      notifications: [],
      privacy: []
    };

    // Check if the page is viewed in a mobile app or a web browser
    const searchParams = new URLSearchParams(window.location.search),
          isWebView = ("1" === searchParams.get("isMobile")) || (sessionStorage.getItem('source') === 'mobileApp');

    // Set account ID based on the environment and platform (Web or App)
    if (isWebView) { // for app
        clevertap.account.push({ id: '${environment.clevertapId.app}' });
    } else { // for web
        // clevertap.account.push({ id: '${environment.clevertapId.web}' });
    }

    // Set privacy settings for Clevertap
    clevertap.privacy.push({ optOut: !1 });
    clevertap.privacy.push({ useIP: !0 });

    // Dynamically insert Clevertap tracking script into the HTML
    (function () {
      var wzrk = document.createElement('script');
      wzrk.type = 'text/javascript';
      wzrk.async = true;
      wzrk.src = ('https:' == document.location.protocol ? 'https://d2r1yp2w7bby2u.cloudfront.net' :
          'http://static.clevertap.com') + '/js/clevertap.min.js';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(wzrk, s);
    })();

    // Function to get the value of a cookie by name
    function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    // Variable to store the authentication type
    var varAuthType;

    // Try to get the value of the "authType" cookie and set the authentication type
    try {
      var a = getCookie("authType");
      if (a == "I" || a == "A") {
        varAuthType = "Identified";
      }
      else {
        varAuthType = "UnIdentified";
      }
    } catch (err) {
      varAuthType = "NA";
    }

    // Trigger a Clevertap 'page_view' event with page URL and authentication type
    setTimeout(() => {
        if(!isWebView) {
          console.log('Clevertap page_view', {
            "page_url": document.URL,
            "authType": varAuthType,
          });
          clevertap.event.push("page_view", {
            "page_url": document.URL,
            "authType": varAuthType,
          });
        }
    }, 1000);

    // Variable to store whether it's a Progressive Web App (PWA)
    var isPWA = 0;

    // Try to determine if it's a PWA
    try {
      isPWA = window.matchMedia("(display-mode: standalone)").matches ? 1 : 0;
    }
    catch (a) {
      isPWA = 0;
    }

    // If it's not a web view, trigger an additional 'page_view' event
    // isWebView || clevertap.event.push("page_view", { page_url: document.URL, authType: varAuthType });
  `;
  }
}
